import { render } from "./SearchError.vue?vue&type=template&id=740855a4&scoped=true"
import script from "./SearchError.vue?vue&type=script&lang=js"
export * from "./SearchError.vue?vue&type=script&lang=js"

import "./SearchError.vue?vue&type=style&index=0&id=740855a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740855a4"]])

export default __exports__